import { StringParam, withDefault } from 'use-query-params';
import {
  CustomStringParam,
  FilterType,
  SchemaFilterType,
  SortDir,
} from '@ui/src';

export const columnsItems = [
  {
    name: 'id',
    label: '',
    hidden: true,
  },
  {
    name: 'transferDate',
    label: 'Date',
    sortable: true,
  },
  {
    name: 'counterpartyAccountNumber',
    label: 'Account No.',
  },
  {
    name: 'counterpartyAccountDescription',
    label: 'Account Description',
  },
  {
    name: 'currencyId',
    label: 'Currency',
    sortable: false,
  },
  {
    name: 'debitSum',
    label: 'Debit',
    sortable: true,
  },
  {
    name: 'creditSum',
    label: 'Credit',
    sortable: true,
  },
  {
    name: 'balance',
    label: 'Balance',
    filterModalPlacement: 'right',
  },
];

export const columnsLabels = {
  transferDate: 'Date',
  transferDateFrom: 'Date From',
  transferDateTo: 'Date To',
  type: 'Type',
  currencyId: 'Currency',
  documentNumber: 'Doc ID',
  debitSum: 'Debit',
  creditSum: 'Credit',
  sort: 'Sort name',
  sortDir: 'Sort direction',
};

export const defaultSorter = {
  sortProp: columnsItems[1].name,
  sortDir: SortDir.DESC,
};

export const schema = {
  transferDate: {
    value: CustomStringParam,
    type: SchemaFilterType.DATE_RANGE,
    queryNames: ['transferDateFrom', 'transferDateTo'],
  },
  transferDateFrom: {
    value: CustomStringParam,
    type: SchemaFilterType.DATE_RANGE,
  },
  transferDateTo: {
    value: CustomStringParam,
    type: SchemaFilterType.DATE_RANGE,
  },
  account: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  currencyId: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  debitSum: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  creditSum: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  documentNumber: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  sortProp: {
    value: withDefault(StringParam, defaultSorter.sortProp),
    type: SchemaFilterType.STRING,
  },
  sortDir: {
    value: withDefault(StringParam, defaultSorter.sortDir),
    type: SchemaFilterType.STRING,
  },
};

export const filtersSchema = [
  {
    name: 'transferDate',
    type: FilterType.DATE_RANGE,
    pickerType: 'twoPickers',
  },
  {
    name: 'currencyId',
    type: FilterType.AUTOCOMPLETE_MULTIPLE,
    placeholder: 'Enter currency...',
  },
  {
    name: 'account',
    type: FilterType.TEXT,
  },
];
